import React, { useEffect, useState } from 'react';

const fetchAndParseRSS = async (rssUrl) => {
      const response = await fetch(rssUrl);
      const text = await response.text();

      const parser = new DOMParser();
      const doc = parser.parseFromString(text, "text/xml");

      // Extracting items
      const items = Array.from(doc.querySelectorAll("item")).map(item => ({
            title: item.querySelector("title")?.textContent,
            link: item.querySelector("link")?.textContent,
            pubDate: item.querySelector("pubDate")?.textContent,
      }));

      return items;
};

const NewsFeed = () => {
      const [items, setItems] = useState([]);
      const [error, setError] = useState(null);
      const [currentPage, setCurrentPage] = useState(1);
      const [itemsPerPage] = useState(5); // Show 5 items per page

      useEffect(() => {
            const fetchNews = async () => {
                  try {
                        const response = await fetch('https://miexistence.mieros.cloud/api/rss', {
                              headers: {
                                    'Accept': 'application/json'
                              }
                        });
                        
                        if (!response.ok) {
                              throw new Error(`HTTP error! status: ${response.status}`);
                        }
                        
                        const data = await response.json();
                        setItems(data);
                  } catch (error) {
                        console.error('Error fetching news:', error);
                        setError('Failed to load news feed. Please try again later.');
                  }
            };

            fetchNews();
      }, []);

      // Calculate pagination values
      const indexOfLastItem = currentPage * itemsPerPage;
      const indexOfFirstItem = indexOfLastItem - itemsPerPage;
      const currentItems = items.slice(indexOfFirstItem, indexOfLastItem);
      const totalPages = Math.ceil(items.length / itemsPerPage);

      // Handle page changes
      const handlePageChange = (pageNumber) => {
            setCurrentPage(pageNumber);
      };

      if (error) {
            return <div className="error-message">{error}</div>;
      }

      return (
            <div>
                  <h2>Latest News (BBC, Reuters, NPR)</h2>
                  <ul style={{ listStyle: 'none', padding: 0 }}>
                        {currentItems.map((item, index) => (
                              <li key={index} style={{ marginBottom: '10px' }}>
                                    <a href={item.link} target="_blank" rel="noopener noreferrer">
                                          {item.title}
                                    </a><br />
                                    <small>
                                          {item.pubDate} | {item.source}
                                    </small>
                              </li>
                        ))}
                  </ul>

                  {/* Updated pagination controls */}
                  <div style={{ 
                        display: 'flex', 
                        justifyContent: 'center', 
                        gap: '5px', 
                        marginTop: '20px',
                        flexWrap: 'wrap'
                  }}>
                        <button 
                              onClick={() => handlePageChange(currentPage - 1)}
                              disabled={currentPage === 1}
                              style={{
                                    padding: '5px 10px',
                                    border: '1px solid #ccc',
                                    background: 'white',
                                    cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
                                    borderRadius: '4px'
                              }}
                        >
                              Previous
                        </button>
                        
                        {[...Array(totalPages)].map((_, index) => (
                              <button
                                    key={index + 1}
                                    onClick={() => handlePageChange(index + 1)}
                                    style={{
                                          padding: '5px 10px',
                                          border: '1px solid #ccc',
                                          background: currentPage === index + 1 ? '#321fdb' : 'white',
                                          color: currentPage === index + 1 ? 'white' : '#321fdb',
                                          cursor: 'pointer',
                                          borderRadius: '4px',
                                          minWidth: '35px'
                                    }}
                              >
                                    {index + 1}
                              </button>
                        ))}

                        <button 
                              onClick={() => handlePageChange(currentPage + 1)}
                              disabled={currentPage === totalPages}
                              style={{
                                    padding: '5px 10px',
                                    border: '1px solid #ccc',
                                    background: 'white',
                                    cursor: currentPage === totalPages ? 'not-allowed' : 'pointer',
                                    borderRadius: '4px'
                              }}
                        >
                              Next
                        </button>
                  </div>
            </div>
      );
};

export default NewsFeed;
